import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { FaTrash, FaEdit, FaInfoCircle } from "react-icons/fa";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

class ListGroupUserComponent extends Component {
    render() {
        return (
            <tr>
                <td>
                    <Link to={ '/admin/nhom-khach-hang/chi-tiet-nhom-khach-hang/' + this.props.groupUser.id }>{ this.props.groupUser.name }</Link>
                </td>
                <td>{ this.props.groupUser.count_user }</td>
                <td>{ this.props.groupUser.count_group_product }</td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chi tiết
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link to={ '/admin/nhom-khach-hang/chi-tiet-nhom-khach-hang/' + this.props.groupUser.id }  className="btn btn-info btn-sm mr-1">
                            <FaInfoCircle />
                        </Link>
                    </OverlayTrigger>
                    {
                        this.props.groupUser.id ? (
                            <>
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Chỉnh sửa
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="btn btn-warning btn-sm mr-1 text-light" onClick={ () => this.props.showModal( this.props.groupUser, 'edit' ) }>
                                        <FaEdit />
                                    </button>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Xóa đại lý
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.groupUser, 'delete' ) }>
                                        <FaTrash />
                                    </button>
                                </OverlayTrigger>
                            </>
                        ) : (
                            <></>
                        )
                    }
                </td>
            </tr>
        );
    }
}

export default ListGroupUserComponent;